module.exports = __webpack_public_path__ + "static/media/mapi32_501.5991d67d.ico";